import React from 'react';
import PropTypes from 'prop-types';

import { Divider as MUIDivider } from '@material-ui/core';

export const Divider = props => <MUIDivider {...props} />;

Divider.propTypes = {
  classes: PropTypes.object,
  flexItem: PropTypes.bool,
  light: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};

export default Divider;
